import React from 'react';
import { useReveal } from '../lib/useReveal';
const CARDS = [{
  icon: '🌿',
  title: 'Comprender síntomas desde una mirada emocional',
  desc: 'Aprendé a identificar patrones emocionales, conflictos biológicos y la relación entre emoción y síntoma.'
}, {
  icon: '📖',
  title: 'Incorporar herramientas aplicables',
  desc: 'Accedé a protocolos, preguntas, estructuras de sesión y recursos prácticos listos para utilizar.'
}, {
  icon: '✨',
  title: 'Desarrollo personal y profesional',
  desc: 'Utilizá estos conocimientos para crecimiento personal o como complemento profesional holístico.'
}];
export function TransformationSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-[#E8E0D3] py-5 md:py-10 px-5 sm:px-6 border-t border-[#2E4F48]/15" data-id="element-341">
      <div className="container mx-auto max-w-5xl" data-id="element-342">
        <div ref={ref} className={`reveal text-center mb-6 ${vis ? 'is-visible' : ''}`} data-id="element-343">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#1C3B36]" data-id="element-344">
            ¿Qué vas a lograr con esta formación?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-345">
          {CARDS.map((card, i) => {
          const [cardRef, cardVis] = useReveal();
          return <div key={i} ref={cardRef} className={`reveal bg-[#ffffff] border border-[#2E4F48]/20 rounded-2xl p-7 text-center transition-all hover:border-[#C2683D]/60 hover:shadow-lg shadow-sm ${cardVis ? 'is-visible' : ''}`} style={{
            transitionDelay: `${i * 100}ms`
          }} data-id="element-346">
                <div className="text-4xl mb-4" data-id="element-347">{card.icon}</div>
                <h3 className="text-[#1C3B36] font-serif font-bold text-xl mb-3 leading-tight" data-id="element-348">
                  {card.title}
                </h3>
                <p className="text-[#1C3B36] text-sm leading-relaxed" data-id="element-349">
                  {card.desc}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}